import { z } from '@/utils/zod'

export const contactTypeValues = [
    'member',
    'address',
    'customer',
    'sponsor',
    'contributor',
    'employee',
    'supplier',
] as const

export const contactTypeTargetValues = contactTypeValues.map((type) => `contact:${type}` as const) as [
    `contact:${(typeof contactTypeValues)[number]}`,
    ...`contact:${(typeof contactTypeValues)[number]}`[],
]

export const isContactType = (value: unknown): value is ContactType => {
    return typeof value === 'string' && (contactTypeValues as readonly string[]).includes(value)
}

export const ContactTypeSchema = z.enum(contactTypeValues)

export type ContactType = z.infer<typeof ContactTypeSchema>
